import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../../../common/utils/logger';

export const onUpdatePin: (
	nonPrivacySafeAttributes: {
		title: string;
		url: string;
		keyPhrases: string[];
		description: string | undefined;
	},
	source: string,
) => AnalyticsEventPayload = (
	nonPrivacySafeAttributes: {
		title: string;
		url: string;
		keyPhrases: string[];
		description: string | undefined;
	},
	source: string,
): AnalyticsEventPayload => {
	try {
		return {
			action: 'clicked',
			actionSubject: 'aiSearchBookmarkUpdateButton',
			eventType: 'ui',
			nonPrivacySafeAttributes,
			source,
		};
	} catch (error) {
		logger.error({
			feature: 'bookmarks',
			element: 'container',
			operation: 'build-analytics',
			category: 'invariant',
			telemetryOnly: true,
			error,
			functionName: 'onUpdatePin',
		});
		return {};
	}
};
